import { render, staticRenderFns } from "./ModalArticle.vue?vue&type=template&id=05842a40&scoped=true"
import script from "./ModalArticle.vue?vue&type=script&lang=js"
export * from "./ModalArticle.vue?vue&type=script&lang=js"
import style0 from "./ModalArticle.vue?vue&type=style&index=0&id=05842a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05842a40",
  null
  
)

export default component.exports